import { Link } from "react-router-dom";

export default function TFDSelectPlayerHistory() {
	return (
		<div className="tfd-select-player-history">
			<section className="tf-hero-player-history">
				<div className="hero-image-wrap">
					<img
						src="/images/select/player-history-hero.jpg"
						alt="Player History"
						className="hero-bg-image"
					/>
					<div className="overlay-dark" />
					<div className="hero-content themeflat-container">
						<h1 className="hero-title wow fadeInUp animated">Player History</h1>
						<p className="hero-subtitle wow fadeInUp animated">
							Celebrating Our Success Stories
						</p>
					</div>
				</div>
			</section>

			<section className="tf-player-history-info main-content">
				<div className="themeflat-container">
					<div className="title-box center-title-box title-large">
						<h2 className="title-section wow fadeInUp animated">
							Alumni Achievements
						</h2>
						<p className="sub-title wow fadeInUp animated">
							Many TFD SELECT graduates have progressed to elite levels.
						</p>
					</div>

					{/* Example of a small "success story" grid */}
					<div className="row">
						<div className="col-md-4 wow fadeInUp animated">
							<div className="history-card">
								<img
									src="/images/select/history1.jpg"
									alt="Player 1"
									className="history-img"
								/>
								<h4 className="player-name">Jordan Smith</h4>
								<p className="achievement">
									Signed with a national youth team after 2 seasons at TFD.
								</p>
							</div>
						</div>

						<div
							className="col-md-4 wow fadeInUp animated"
							data-wow-delay="0.2s"
						>
							<div className="history-card">
								<img
									src="/images/select/history2.jpg"
									alt="Player 2"
									className="history-img"
								/>
								<h4 className="player-name">Sophie Walker</h4>
								<p className="achievement">
									Earned a scholarship to a top football academy in Europe.
								</p>
							</div>
						</div>

						<div
							className="col-md-4 wow fadeInUp animated"
							data-wow-delay="0.4s"
						>
							<div className="history-card">
								<img
									src="/images/select/history3.jpg"
									alt="Player 3"
									className="history-img"
								/>
								<h4 className="player-name">Liam Chen</h4>
								<p className="achievement">
									Competed in international tournaments across Asia.
								</p>
							</div>
						</div>
					</div>

					<div className="text-center mt-5">
						<p>
							Do you have a success story to share? We’d love to hear from you.
						</p>
						<Link to="/contact" className="flat-button">
							Contact Us
						</Link>
					</div>
				</div>
			</section>
		</div>
	);
}
